export const Slugify = (str) => {
    return String(str)
    .normalize('NFKD') // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // accents to be \u03xx UNICODE
    .trim() // trim whitespace
    .toLowerCase() // to lowercase
    .replace(/&amp;|&/g, '-et-')
    .replace(/[^a-z0-9 -]/g, '') // non-alphanumeric characters
    .replace(/\s+/g, '-') // spaces with hyphens
    .replace(/'/g, '-') // quote
    .replace(/-+/g, '-') // consecutive hyphens
}